import { useState } from 'react';
import {
    FormControl,
    Stack,
    FormLabel,
    Box,
    Text,
    VStack,
} from '@chakra-ui/react';
import { Field } from 'formik';
import DropDown from 'components/forms/new/formikFormFields/DropDown';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    descriptionStyling,
} from 'components/forms/new/formStyles';
import walkthroughIds from '../../../walkthroughIds';
import FieldToolTip from 'components/forms/new/FieldToolTip';

const SBCaaSMaxRedundancyField = ({ options, darkMode }) => {
    const [isHovered, setIsHovered] = useState(false);
    const maxRedundancyData = (options || []).map((opt) => ({
        id: opt.value,
        name: opt.name,
    }));
    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={stackStyling(true)}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Max Redundancy Level{' '}
                        <span style={{ color: '#e53e3e' }}>*</span>
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Select the maximum redundancy level for this SBCaaS
                        profile.
                    </Text>
                </Box>
                <Box flex="1" minWidth="450px">
                    <Box
                        sx={{
                            display: 'flex',
                            width: '100%',
                            alignItems: 'flex-start',
                            paddingTop: '15px',
                        }}>
                        <VStack width="100%" alignItems="normal">
                            <Field
                                name="maxRedundancy"
                                validate={(value) =>
                                    !value && 'Max Redundancy is required'
                                }>
                                {({ field, form, meta }) => (
                                    <>
                                        <DropDown
                                            field={field}
                                            form={form}
                                            name="maxRedundancy"
                                            data={maxRedundancyData}
                                            shownValue="name"
                                            walkthroughId={
                                                walkthroughIds.serviceProfiles
                                                    ?.ufMaxRedundancyLevelSelect
                                            }
                                            placeholder="- Select Max Redundancy -"
                                            darkMode={darkMode}
                                            width="100%"
                                            noPadding
                                            handleSelectChange={(item) =>
                                                form.setFieldValue(
                                                    'maxRedundancy',
                                                    item?.id,
                                                )
                                            }
                                        />
                                        {meta.touched && meta.error && (
                                            <Text
                                                color="red.500"
                                                fontSize="xs"
                                                mt={1}
                                                textAlign="right">
                                                {meta.error}
                                            </Text>
                                        )}
                                    </>
                                )}
                            </Field>
                        </VStack>
                    </Box>
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Select the maximum redundancy level."
                        ariaLabel="sbcaas-max-redundancy-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default SBCaaSMaxRedundancyField;
